import type { TeacherLessonRecord } from "../auth/api-client";

export function buildSoftDeleteLessonConfirmMessage(lesson: TeacherLessonRecord): string {
  const lines = [`Move “${lesson.title}” to Recently Deleted?`];
  const templates = lesson.usedInTemplates ?? 0;
  const cohorts = lesson.activeCohorts ?? 0;
  if (templates > 0) {
    lines.push(
      `This lesson is part of ${templates} course${templates === 1 ? "" : "s"}. It will be removed from those sequences.`
    );
  }
  if (cohorts > 0) {
    lines.push(
      `It is assigned in ${cohorts} active cohort${cohorts === 1 ? "" : "s"}. Student work there is preserved.`
    );
  }
  lines.push("You can restore it later from Actions → See Recently Deleted Lessons.");
  return lines.join("\n\n");
}

export function buildRemoveTemplateLessonConfirmMessage(title: string): string {
  return `Remove “${title}” from this course sequence? The lesson stays in your library.`;
}

export function buildDeleteCourseConfirmMessage(title: string, activeCohorts: number): string {
  const lines = [`Delete course “${title}”?`];
  if (activeCohorts > 0) {
    lines.push(
      `This course is the basis for ${activeCohorts} active cohort${activeCohorts === 1 ? "" : "s"}. Those cohorts will continue with their existing lesson plans and assignments. Only the reusable course is removed from your library.`
    );
  } else {
    lines.push("It will be removed from your library. Existing cohorts are unaffected.");
  }
  return lines.join("\n\n");
}

/** @deprecated Use buildDeleteCourseConfirmMessage */
export const buildDeleteCourseTemplateConfirmMessage = buildDeleteCourseConfirmMessage;
